import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import breaks from 'remark-breaks';

const MarkDown = ({ source: raw }) => {
  // eslint-disable-next-line no-irregular-whitespace
  const source = raw ? raw.replace(/    /g, '  ') : null;
  return <ReactMarkdown source={source} plugins={[breaks]} className="description" />;
};

MarkDown.propTypes = {
  source: PropTypes.string.isRequired,
};

export default MarkDown;
